import Switch from "rc-switch";
import React, { useCallback, useEffect } from "react";
import { TiCancel } from "react-icons/ti";
import { FiDownload } from "react-icons/fi";
import { useGlobal } from "../../hooks/global";
import { background, primary, secondary, text } from "../../theme";
import { CSSProperties } from "styled-components";
import { AiOutlineRollback } from "react-icons/ai";
import { MagicButton } from "./../Buttons/MagicButton";
import { IconButton, Tooltip } from "@material-ui/core";
import { BsFillBookmarkPlusFill } from "react-icons/bs";
import { ContentOrLoading } from "../Loadings/ContentOrLoading";
import { Table, TD, TH, SwitchContainer, NoData } from "./style";
import { MdOutlineArrowDropDownCircle } from "react-icons/md";
import { Menu } from "@mantine/core";
import NoFoundData, { moduleName } from "../NoFoundData";

export interface ITable {
  data: { [key: string]: any }[];
  columns: {
    attr: string;
    name: string;
    style: CSSProperties;
    styleContent: CSSProperties;
    limitWidth?: boolean;
  }[];
}

export interface ITableList {
  table: ITable;
  loading: boolean;
  have_status_franchise?: boolean;
  have_status?: boolean;
  have_switch?: boolean;
  switch_checked?: any;
  have_delete?: boolean;
  have_cancel?: boolean;
  have_accept?: boolean;
  have_rollback?: boolean;
  have_is_test_free?: boolean;
  have_download?: boolean;
  have_default?: boolean;
  haveIsTrusted?: boolean;
  statusText?: string;
  switchText?: string;
  textDelete?: string;
  accept_action?: (id: any) => void;
  cancel_action?: (id: any) => void;
  rollback_action?: (id: any) => void;
  status_action?: (_id: any, old_status: any) => void;
  switch_action?: (item: any) => void;
  change_default_action?: (_id: any, old_status: any) => void;
  is_test_free_action?: (_id: any, old_status: any) => void;
  haveIsTrustedAction?: (_id: any, old_status: any) => void;
  canEdit?: (item: any) => boolean;
  canCancel?: (item: any) => boolean;
  canRollback?: (item: any) => boolean;
  canDownload?: (item: any) => boolean;
  getUrlDownload?: (item: any) => string;
  text_loading: string;
  text_empty: string;
  moduleName?: moduleName;
  getTextDownload?: (item: any) => string;
  onChangeSelecteds?: (selecteds: any[]) => void;
  listActions?: any[];
  beforeListActions?: any[];
  noActions?: boolean;
  noHeader?: boolean;
}

export const TableList: React.FC<ITableList> = (props) => {
  const {
    table,
    loading,
    have_status_franchise,
    have_status,
    have_switch,
    switch_checked,
    have_cancel,
    have_accept,
    have_rollback,
    have_is_test_free,
    have_download,
    have_default,
    accept_action = () => { },
    cancel_action = () => { },
    rollback_action = () => { },
    status_action = () => { },
    change_default_action = () => { },
    is_test_free_action = () => { },
    canCancel = () => true,
    canRollback = () => true,
    canDownload = () => true,
    noHeader = false,
    text_empty,
    moduleName = 'default',
    text_loading,
    switch_action = () => { },
    statusText = "Status",
    switchText = "Status",
    getUrlDownload = () => "",
    getTextDownload = () => "Download",
    listActions = [],
    beforeListActions = [],
    haveIsTrusted,
    haveIsTrustedAction = () => { },
    noActions = false,
  } = props;

  const { theme, getCorrectMaxWidth } = useGlobal();

  const handleDownload = useCallback((id: string) => {
    const anchor = document.getElementById(id);
    if (anchor) anchor.click();
  }, []);

  const listActionsEnabled = listActions.filter((action) => !action.disabled());

  function extractTextLinesFromReactElement(element: any): string[] {
    if (typeof element === "string" || typeof element === "number") {
      return [String(element)];
    }

    if (Array.isArray(element)) {
      return element.flatMap(extractTextLinesFromReactElement);
    }

    if (React.isValidElement(element)) {
      //@ts-ignore
      return extractTextLinesFromReactElement(element.props?.children);
    }

    return [];
  }

  return (
    <ContentOrLoading loading={loading} text={text_loading} theme={theme}>
      {table.data.length > 0 && (
        <div
          style={{
            display: "flex",
            overflow: "auto",
            maxWidth: getCorrectMaxWidth(),
          }}
        >
          <Table>
            <thead>
              <tr>
                {!noHeader && table.columns
                  .map(({ attr, name, style }, index) => (
                    <TH key={attr + index} style={{ ...style }}>
                      {name}
                    </TH>
                  ))}
                {!noHeader && (have_switch) && (
                  <TH style={{ textAlign: "center" }}>{switchText}</TH>
                )}
                {!noHeader && (have_status || have_status_franchise) && (
                  <TH style={{ textAlign: "center" }}>{statusText}</TH>
                )}
                {!noHeader && !noActions && <TH style={{ textAlign: "center" }}>Ações</TH>}
              </tr>
            </thead>
            <tbody>
              {table.data.map((item, key) => (
                <tr
                  key={key + item?.this?.id}
                  style={{
                    background: primary[theme],
                    borderRadius: 5,
                    boxShadow: "0.125rem 0.125rem 0.5rem #57545419",
                  }}
                >
                  {table.columns
                    .filter((column) => column.attr === "indicator")
                    .map(({ attr, styleContent, limitWidth }, index) => (
                      <TD
                        key={index}
                        noHaveClick
                        isLeft
                        className={limitWidth ? "overflow-name-table" : ""}
                        noData={
                          !(["0", 0].includes(item[attr]) || !!item[attr])
                        }
                        style={{ ...styleContent }}
                      >
                        {item[attr] ?? "Não informado"}
                      </TD>
                    ))}
                  {table.columns
                    .filter((column) => column.attr !== "indicator")
                    .map(({ attr, styleContent, limitWidth }, index) => {

                      const rawValue = item[attr];
                      const linesTitle = extractTextLinesFromReactElement(rawValue);
                      const titleText = linesTitle.filter((line) => line?.toString().trim()).join(" | ");

                      return (
                        <TD
                          noHaveClick={!!noActions}
                          key={index}
                          isLeft={index === 0}
                          onClick={() => {
                            const action = listActions?.find((action) => action.title === 'Editar');
                            if (action) {
                              action.onClick(item.this);
                            } else {
                              console.warn('Ação "Editar" não encontrada!');
                            }
                          }}
                          className={limitWidth ? "overflow-name-table" : ""}
                          noData={
                            !(["0", 0].includes(item[attr]) || !!item[attr])
                          }
                          title={titleText}
                          style={{ ...styleContent, textTransform: "uppercase" }}
                        >
                          {item[attr] ?? "Não informado"}
                        </TD>
                      )
                    })}

                  {haveIsTrusted && (
                    <TD
                      noHaveClick
                      style={{ padding: 10, textAlign: "center" }}
                    >
                      <SwitchContainer theme={theme}>
                        <Switch
                          className="custom-switch custom-switch-primary custom-switch-small"
                          checked={item.this.is_trusted}
                          onClick={() =>
                            haveIsTrustedAction(
                              item.this.id,
                              item.this.is_trusted
                            )
                          }
                        />
                      </SwitchContainer>
                    </TD>
                  )}

                  {have_switch && (
                    <TD
                      noHaveClick
                      style={{ padding: 10, textAlign: "center" }}
                    >
                      <SwitchContainer theme={theme}>
                        <Switch
                          className="custom-switch custom-switch-primary custom-switch-small"
                          checked={item.this?.[switch_checked]}
                          onClick={() =>
                            switch_action(item?.this)
                          }
                        />
                      </SwitchContainer>
                    </TD>
                  )}

                  {have_status && (
                    <TD
                      noHaveClick
                      style={{ padding: 10, textAlign: "center" }}
                    >
                      <SwitchContainer theme={theme}>
                        <Switch
                          className="custom-switch custom-switch-primary custom-switch-small"
                          checked={
                            item?.this?.user
                              ? item.this.user.status === "active"
                              : item?.this?.active != null
                                ? item.this.active
                                : item?.this?.status === true || item?.this?.status === "active"
                          }
                          onClick={() => {
                            const data = item?.this;

                            if (data?.user) {
                              status_action(data.user.id, data.user.status);
                            } else if (data?.status !== undefined) {
                              status_action(data.id, data.status);
                            } else {
                              status_action(data?.id, data?.active);
                            }
                          }}
                        />
                      </SwitchContainer>
                    </TD>
                  )}

                  {have_default && (
                    <TD
                      noHaveClick
                      style={{ padding: 10, textAlign: "center" }}
                    >
                      <MagicButton
                        type="radio"
                        checked={item?.this?.is_default}
                        label=""
                        onClick={() =>
                          change_default_action(
                            item?.this?.id,
                            item?.this?.is_default
                          )
                        }
                        theme={theme}
                      />
                    </TD>
                  )}

                  {have_status_franchise && (
                    <TD
                      noHaveClick
                      style={{ padding: 10, textAlign: "center" }}
                    >
                      <SwitchContainer theme={theme}>
                        <Switch
                          className="custom-switch custom-switch-primary custom-switch-small"
                          checked={item.this.status === "active"}
                          onClick={() =>
                            status_action(item.this.id, item.this.status)
                          }
                        />
                      </SwitchContainer>
                    </TD>
                  )}

                  {have_is_test_free && (
                    <TD
                      noHaveClick
                      style={{ padding: 10, textAlign: "center" }}
                    >
                      <MagicButton
                        type="radio"
                        checked={item.this.is_test_free}
                        label=""
                        onClick={() =>
                          is_test_free_action(
                            item.this.id,
                            item.this.is_test_free
                          )
                        }
                        theme={theme}
                      />
                    </TD>
                  )}

                  {!noActions && (
                    <TD
                      noHaveClick
                      isRight
                      style={{ textAlign: "center", whiteSpace: "nowrap" }}
                    >
                      {beforeListActions.map((action, index) => {
                        if (action.disabled(item.this)) return null;
                        return (
                          <Tooltip
                            key={action?.title + index}
                            onClick={() => action.onClick(item.this)}
                            title={action.title}
                            style={{ margin: 0, padding: 8 }}
                          >
                            <IconButton aria-label={action.title}>
                              {action.icon}
                            </IconButton>
                          </Tooltip>
                        );
                      })}

                      {listActionsEnabled.length > 1 ? (
                        <Menu shadow="md" position="bottom-end">
                          <Menu.Target>
                            <IconButton aria-label={"Editar"} style={{ margin: 0, padding: 8 }}>
                              <MdOutlineArrowDropDownCircle
                                color={secondary[theme]}
                                size={20}
                              />
                            </IconButton>
                          </Menu.Target>

                          <Menu.Dropdown
                            bg={background[theme]}
                            style={{ border: "none" }}
                          >
                            {listActions.map((action, index) => {
                              if (action.disabled(item.this)) return null;
                              return (
                                <Menu.Item
                                  onClick={() => action.onClick(item.this)}
                                  key={action.title + index}
                                  c={text[theme]}
                                  style={{ fontFamily: "Poppins", fontSize: 11, fontWeight: 600 }}
                                  sx={{
                                    "&:hover": {
                                      backgroundColor: primary[theme],
                                      color: secondary[theme]
                                    },
                                  }}
                                >
                                  <div style={{ display: "flex", flexDirection: "row", gap: 5, alignItems: "center", textTransform: 'uppercase' }}>
                                    <IconButton
                                      aria-label={action.title}
                                      size="small"
                                    >
                                      {action.icon}
                                    </IconButton>
                                    {action?.title}
                                  </div>
                                </Menu.Item>
                              );
                            })}
                          </Menu.Dropdown>
                        </Menu>
                      ) : (
                        listActions.map((action) => {
                          if (action.disabled(item.this)) return null;
                          return (
                            <Tooltip
                              key={action.title}
                              onClick={() => action.onClick(item.this)}
                              style={{ margin: 5 }}
                              title={action.title}
                            >
                              <IconButton aria-label={action.title}>
                                {action.icon}
                              </IconButton>
                            </Tooltip>
                          );
                        })
                      )}

                      {have_download && canDownload(item.this) && (
                        <Tooltip
                          onClick={() => handleDownload(item.this.id)}
                          title={getTextDownload(item.this)}
                          style={{ margin: 5 }}
                        >
                          <IconButton aria-label={getTextDownload(item.this)}>
                            <FiDownload color={secondary[theme]} size={20} />
                            <a
                              id={item.this.id}
                              href={getUrlDownload(item.this)}
                              target="_blank"
                              style={{ display: "none" }}
                            />
                          </IconButton>
                        </Tooltip>
                      )}
                      {have_cancel && canCancel(item.this) && (
                        <Tooltip
                          onClick={() => cancel_action(item.this)}
                          title={"Cancelar"}
                          style={{ margin: 5 }}
                        >
                          <IconButton aria-label={"Cancelar"}>
                            <TiCancel color={secondary[theme]} size={20} />
                          </IconButton>
                        </Tooltip>
                      )}
                      {have_rollback && canRollback(item.this) && (
                        <Tooltip
                          onClick={() => rollback_action(item.this)}
                          title={"Desfazer Cancelamento"}
                          style={{ margin: 5 }}
                        >
                          <IconButton aria-label="Desfazer Cancelamento">
                            <AiOutlineRollback
                              color={secondary[theme]}
                              size={20}
                            />
                          </IconButton>
                        </Tooltip>
                      )}
                      {have_accept && (
                        <Tooltip
                          onClick={() => accept_action(item.this)}
                          style={{
                            margin: 5,
                            borderRadius: 4,
                            background: secondary[theme],
                            padding: 5,
                          }}
                          title="Assumir oportunidade"
                        >
                          <IconButton aria-label="Assumir oportunidade">
                            <BsFillBookmarkPlusFill size={20} color="#FFF" />
                          </IconButton>
                        </Tooltip>
                      )}
                    </TD>
                  )}
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )}
      {table.data.length === 0 && (
        <>
          <NoFoundData message={text_empty} moduleName={moduleName} />
          {/*     <NoData>{text_empty}</NoData> */}
        </>
      )}
    </ContentOrLoading>
  );
};
